// extracted by mini-css-extract-plugin
module.exports = {"head":"Filters_head__1CcES","section":"Filters_section__2tSO2"};